import { LitElement, html, css } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";

export class AccountPanel extends LitElement {
	static properties = {
		name : {type : String},
		bank : {type : String},
		rib : {type : String},
		bic : {type : String},
		iban : {type : String},
		reference : {type : String}
	};
	
	render (){
		return (!this.name || this.name === "undefined") ?
		html`Pas disponible<br/>` :
		html`
			Le virement doit être fait sur le compte suivant :<br/>
			<b>${this.name ?? ""} / ${this.bank ?? ""} / RIB : ${this.rib ?? ""} / IBAN : ${this.iban ?? ""} / BIC : ${this.bic ?? ""} </b><br/>
			Référence à indiquer dans votre ordre de virement : <b>${this.reference ?? ""}</b>.<br/>
			Une attestation de publication vous sera adressée par email après réception du virement.
		`;
	}
}

customElements.define ("account-panel", AccountPanel);